<template>
  <div v-if="show" class="spinner">
    <div v-if="type === 'default'" class="spinner-default" :class="spinnerBasicStyle"></div>
    <div v-else-if="type === 'dots'" class="spinner-dots" :class="spinnerBasicStyle">
      <div class="spinner-dot-1" :class="spinnerStyle"></div>
      <div class="spinner-dot-2" :class="spinnerStyle"></div>
      <div class="spinner-dot-3" :class="spinnerStyle"></div>
      <div class="spinner-dot-4" :class="spinnerStyle"></div>
    </div>
    <span v-if="text" class="ps-2">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'IpsSpinner',
  props: {
    type: {
      name: 'type',
      description: 'The type of the spinner',
      type: String,
      default: 'default',
      required: false,
      validator: (value) => ['', 'default', 'dots'].indexOf(value) !== -1,
    },
    show: {
      name: 'show',
      description: 'Shows spinner if true',
      type: Boolean,
      default: true,
    },
    size: {
      name: 'size',
      description: 'The size of the spinner',
      type: String,
      default: 'md',
      required: false,
      validator: (value) => ['', 'sm', 'md', 'lg'].indexOf(value) !== -1,
    },
    text: {
      name: 'text',
      description: 'The text shown next to the spinner',
      type: String,
      default: null,
      required: false,
    },
  },
  computed: {
    spinnerStyle() {
      switch (this.size) {
        case 'sm':
          return 'spinner-style spinner-style-sm';
        case 'lg':
          return 'spinner-style spinner-style-lg';
        case 'md':
        default:
          return 'spinner-style spinner-style-md';
      }
    },
    spinnerBasicStyle() {
      switch (this.size) {
        case 'sm':
          return 'spinner-basic-style spinner-basic-style-sm';
        case 'lg':
          return 'spinner-basic-style spinner-basic-style-lg';
        case 'md':
        default:
          return 'spinner-basic-style spinner-basic-style-md';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'IpsSpinner';
</style>
